import React from "react";
import { Pressable } from "react-native";
import { useResponsive } from "../../hooks/useResponsive";

const Search = () => {
  const { isMediumAndDown } = useResponsive();

  // smaller screens
  if (isMediumAndDown) return <Pressable />;
  // wider screens
  return <Pressable />;
};

export default Search;
